var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagingDone2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9200_94868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6463 2.23689C24.0678 2.5938 24.1201 3.2248 23.7632 3.64626L9.02316 21.0517L9.02069 21.0546C8.76291 21.3566 8.44099 21.597 8.07944 21.7598C7.71796 21.9226 7.32496 22.0043 6.92875 21.9998C6.52606 21.9949 6.12797 21.9011 5.76581 21.7244C5.40439 21.5481 5.0863 21.2933 4.83657 20.9773L4.83487 20.9752L0.218049 15.1829C-0.126186 14.751 -0.0551351 14.1218 0.376745 13.7776C0.808626 13.4333 1.43779 13.5044 1.78203 13.9363L6.40521 19.7366C6.46701 19.8149 6.5478 19.8806 6.6428 19.927C6.73787 19.9733 6.84372 19.9986 6.9522 20C7.05862 20.001 7.16321 19.979 7.25815 19.9362C7.35276 19.8936 7.43443 19.832 7.49836 19.7574L7.49939 19.7562L22.2369 2.35375C22.5938 1.93229 23.2248 1.87997 23.6463 2.23689Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9200_94868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingDone2);
export default __webpack_public_path__ + "static/media/messaging-done2.b2ade50c3d0eae5394007392231871ef.svg";
export { ForwardRef as ReactComponent };